/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import isArrayEqual from '@jira/platform__is-array-equal/src/index.tsx';

/**
 * Shallow equal using '===' comparison and one-level array checks.
 *
 * WARNING: This is not a true shallow equal, use @jira/platform__utils-shallow-equal.
 *
 * @see {@link http://go.atlassian.com/shallow-equal}
 *
 * @param {*} obj1
 * @param {*} obj2
 * @returns {boolean}
 */

const isShallowEqual = (obj1: unknown, obj2: unknown): boolean => {
	if (obj1 === obj2) {
		return true;
	}

	if (!obj1 || !obj2) {
		return false;
	}

	const item1Keys = Object.keys(obj1).sort();
	const item2Keys = Object.keys(obj2).sort();

	// are keys equal?
	if (!isArrayEqual(item1Keys, item2Keys)) {
		return false;
	}

	// are the values equal?
	const areValuesEqual = item2Keys.every((key) => {
		// @ts-expect-error - TS2571 - Object is of type 'unknown'.
		const value = obj1[key];
		// @ts-expect-error - TS2571 - Object is of type 'unknown'.
		const nextValue = obj2[key];

		if (value === nextValue) {
			return true;
		}

		return Array.isArray(nextValue) && Array.isArray(value) && isArrayEqual(value, nextValue);
	});

	return areValuesEqual;
};

export default isShallowEqual;
